<div class="content-wrapper container-xxl p-0 card">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.SOCIAL_LINKS' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Users
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text">{{ 'MENU.DASHBOARD.SOCIAL_LINKS_LIST' | translate }}</p>
          </div>
        </div>
  
             <div class="row d-flex justify-content-between">
           <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage" class="mr-2">{{ 'MENU.DASHBOARD.SHOW' | translate }}</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm mr-2"
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="mr-1">{{ 'MENU.DASHBOARD.ENTRIES' | translate }}</span>
              </div>
            </div>
          </div> 
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="">{{ 'MENU.DASHBOARD.SEARCH' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.SEARCH' | translate }}"
                class="form-control form-control-sm w-75"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div>
        </div>
        <ngx-datatable
          [rows]="arrCoupons" 
          [rowHeight]="58"
          class="bootstrap core-bootstrap bg-white"
          [limit]="itemsPerPage"
          [columnMode]="ColumnMode.force"
          [headerHeight]="40"
          [footerHeight]="50"
          [scrollbarH]="true"
                      [messages]="{ totalMessage: lang == 'ar' ? 'العدد الكلي' : 'total' }"

        >
          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.ID' | translate }}"
            prop="id"
            [width]="50"
          ></ngx-datatable-column>
   <!-- Platform -->
  <ngx-datatable-column
    name="{{ lang == 'ar' ? 'المنصة' : 'Platform' }}"
    prop="platform"
    [width]="140"
  >
    <ng-template ngx-datatable-cell-template let-row="row">
      <strong class="text-capitalize">
        {{ row.platform }}
      </strong>
    </ng-template>
  </ngx-datatable-column>

  <!-- Link -->
  <ngx-datatable-column
    name="{{ lang == 'ar' ? 'الرابط' : 'Link' }}"
    [width]="300"
  >
    <ng-template ngx-datatable-cell-template let-row="row">
      <a
        [href]="row.link"
        target="_blank"
        class="text-primary text-truncate d-inline-block"
        style="max-width: 280px"
      >
        {{ row.link }}
      </a>
    </ng-template>
  </ngx-datatable-column>

  <!-- Status (is_active) -->
  <ngx-datatable-column
    name="{{ lang == 'ar' ? 'الحالة' : 'Status' }}"
    [width]="120"
  >
    <ng-template ngx-datatable-cell-template let-row="row">
      <span
        class="badge"
        [ngClass]="row.is_active ? 'badge-light-success' : 'badge-light-danger'"
      >
        {{
          row.is_active
            ? ('MENU.DASHBOARD.Active' | translate)
            : ('MENU.DASHBOARD.Inactive' | translate)
        }}
      </span>
    </ng-template>
  </ngx-datatable-column>

  <!-- Order -->
  <ngx-datatable-column
    name="{{ lang == 'ar' ? 'الترتيب' : 'Order' }}"
    prop="order"
    [width]="80"
  >
  </ngx-datatable-column>

  <!-- Updated At -->
  <ngx-datatable-column
    name="{{ lang == 'ar' ? 'آخر تعديل' : 'Updated At' }}"
    [width]="150"
  >
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.updated_at | date: 'dd MMM yyyy' }}
    </ng-template>
  </ngx-datatable-column>
  
          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.ACTIONS' | translate }}"
            [width]="70"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div ngbDropdown container="body">
                <button
                  type="button"
                  class="btn btn-sm hide-arrow"
                  ngbDropdownToggle
                >
                  <i data-feather="more-vertical"></i>
                </button>
                <div ngbDropdownMenu>

<!-- <a
  ngbDropdownItem
  [routerLink]="['/z-users-details', row.id]"
>
  <i  
    data-feather="eye"
    [class]="lang === 'ar' ? 'ml-3' : 'mr-3'"
  ></i>
  <span>{{ "MENU.DASHBOARD.Details" | translate }}</span>
</a> -->

  <!-- <a
                      ngbDropdownItem
                      (click)="deleteUser(row.id)"
                      class="text-danger"
                    >
                      <i data-feather="x-octagon" [class]="lang == 'ar' ? 'ml-1' : 'mr-1'"></i
                      ><span>{{ "MENU.DASHBOARD.closeAcc" | translate }}</span>
                    </a> -->
                  <!-- <a
                    ngbDropdownItem
                    [routerLink]="['/main/coupons/edit', row.id]"
                  >
                    <i data-feather="edit-2" class="mr-50"></i
                    ><span>{{ "MENU.Edit" | translate }}</span>
                  </a> -->
                  <!-- <a ngbDropdownItem (click)="confirmDelete(row.id)">
                    <i data-feather="trash" class="mr-50"></i
                    ><span>{{ "MENU.Delete" | translate }}</span>
                  </a> -->

                        <a
                    ngbDropdownItem
                    [routerLink]="['/z-edit-social-links', row.id]"
                  >
                    <i data-feather="edit-2"   [class]="lang === 'ar' ? 'ml-3' : 'mr-3'"></i
                    ><span>{{ "MENU.DASHBOARD.EDIT" | translate }}</span>
                  </a>
                  <a ngbDropdownItem (click)="confirmDelete(row.id)">
                    <i data-feather="trash"   [class]="lang === 'ar' ? 'ml-3' : 'mr-3'"></i
                    ><span>{{ "MENU.DASHBOARD.DELETE" | translate }}</span>
                  </a>
                </div>
              </div> 
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable> 
      </section>
    </div>
  </div>
  